module.exports = __webpack_public_path__ + "img/2024-10.3a8853ae.jpg";